const COMBINING_MARKS = /[\u0300-\u036f]/g;

export const normalizeSearchText = text =>
    String(text ?? '')
        .toLowerCase()
        .normalize('NFD')
        .replace(COMBINING_MARKS, '')
        .trim();

export const searchTerms = query => normalizeSearchText(query).split(/\s+/).filter(Boolean);
